import { CustomField, CustomFieldDivider, ProductVariant, SwatchData, VariantImage } from '../types'

export const getRelevantCustomFields = (
  dividers: Array<CustomFieldDivider>,
  category: string
): Array<CustomFieldDivider> => {
  return dividers
    .map(divider => {
      // we only want divider that have custom fields that have no assigned_taxonomy values
      // or ones that match the current product's category
      const matchingCFs = divider.custom_fields
        ?.filter(
          (field: CustomField) => !field.assigned_taxonomies?.length || field.assigned_taxonomies?.includes(category)
        )
        .map(cf => {
          if ((cf as any).variant_values && (cf as any).variant_values.length) {
            ;(cf as any).variant_values = null
          }
          return cf
        })

      return { ...divider, custom_fields: matchingCFs }
    })
    .filter(divider => divider.custom_fields.length)
}

export const mapVariantObjPropsToIds = (variants: Array<ProductVariant>) => {
  // turns images, color and custom_field variant properties from populated objects to ids
  return variants.map((variant: ProductVariant) => {
    return {
      ...variant,
      images: (variant.images as Array<VariantImage>)?.map(image => image._id as string),
      color: (variant.color as SwatchData)?._id as string,
      custom_fields: variant.custom_fields?.map(cf => ({
        field_info: (cf.field_info as Record<string, string>)?._id || (cf.field_info as string),
        value: cf.value
      }))
    }
  })
}
